import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';

import colors from '@packages/core/styles/colors';

const useDetailViewAsideStyles = createUseStyles({
    aside: {
        display: 'flex',
        flexDirection: 'column',
        width: 390,
        flexShrink: 0,
        overflowY: 'auto',
        backgroundColor: colors.grayOne,
        borderLeft: `1px solid ${colors.grayThree}`,
    },
});

export const PublicationFormDetailViewAside: FC<{ filters: React.ReactNode; children: React.ReactNode }> = ({
    filters,
    children,
}) => {
    const classes = useDetailViewAsideStyles();

    return (
        <div className={classes.aside}>
            <div>{filters}</div>
            <div style={{ padding: '4px 30px' }}>{children}</div>
        </div>
    );
};
